import './Contact.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const Contact = () => {
    return (
        <section className='contact'>
            <div className='contact__content'>
                <div className='contact__content__subtitle text'>
                    - escríbeme -
                </div>
                <div className='contact__content__box'>
                    <div className='contact-box contacto'>
                        <div className='contact-box__info'>
                            <h4>Contacto</h4>
                            <span>¿Te interesa mi trabajo o quieres que forme parte de tu proyecto?</span>
                            <Link to='/contacto'>Ir a contacto</Link>
                        </div>
                    </div>
                    <div className='contact-box portafolio'>
                        <div className='contact-box__info'>
                            <h4>Portafolio</h4>
                            <span>Algunos de los trabajos que 
                            realice</span>
                            <Link to='/portafolio'>Ver portafolio</Link>
                        </div>
                    </div>
                </div>
                <div className='contact__content__media'>
                    <div className='contact__content__media__gmail hover-text'>
                        <FontAwesomeIcon icon={faEnvelope} className='gmail-icon'/>
                        <h4>rod.cond.fredy@gmail.com</h4>
                    </div>
                    <div className='contact__content__media__social'>
                        <div className='social-media'>
                            <a href='https://api.whatsapp.com/send?phone=51968097105&text=Hola, vengo de tu página web...' target='_blank' rel='noreferrer' className='social-media__link hover-text'>
                                <FontAwesomeIcon icon={faWhatsapp} className='social-media__link__icon'/>
                                <h4>Whatsapp</h4>
                            </a>
                        </div>
                        <div className='social-media'>
                            <a href='https://github.com/Fredy-Rodrigo' target='_blank' rel='noreferrer' className='social-media__link hover-text'>
                                <FontAwesomeIcon icon={faGithub} className='social-media__link__icon'/>
                                <h4>Github</h4>
                            </a>
                        </div>
                        <div className='social-media'>
                            <a href='https://www.linkedin.com/in/fredy-rodrigo/' target='_blank' rel='noreferrer' className='social-media__link hover-text'>
                                <FontAwesomeIcon icon={faLinkedin} className='social-media__link__icon'/>
                                <h4>Linkedin</h4>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact;